module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.bed89d96.svg";